import { createContext } from "react";

import { NotificationHelper } from "./NotificationHelper.ts";

export const NotificationContext = createContext<NotificationHelper>(
  {} as NotificationHelper
);
